import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import styles from "./add-menu-but-nope.module.css"

@tagName("")
export default class AddMenuButNope extends Component {
  readonly styles = styles
  canShowAddMenu: boolean = false
  addToRoutineMenuConstraints = [{ to: "window", pin: ["left"] }]
  @action
  toggleAddMenu() {
    set(this, "canShowAddMenu", !get(this, "canShowAddMenu"))
  }
}
